import React from "react";

import { Box } from "../../core";

export const PanelBody = (otherProps: any) => <Box p={4} {...otherProps} />;

export default PanelBody;
